'use client';

import { Button } from '@nextui-org/react';
import { AlertTriangle } from 'lucide-react';
import Link from 'next/link';

import { PageWrapper } from '@/components/layout/page-wrapper/page-wrapper';
import { ROUTES } from '@/shared/routes/routes';

export type ErrorFallbackViewProps = {
  /** Вызывается при клике «На главную» до навигации (сброс React Error Boundary) */
  onNavigateHome?: () => void;
  /** Next.js `reset()` из `error.tsx` */
  onRetry?: () => void;
};

export const ErrorFallbackView = ({
  onNavigateHome,
  onRetry,
}: ErrorFallbackViewProps) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <PageWrapper>
      <div className="text-center flex flex-col items-center justify-center min-h-[50vh] gap-4 px-2">
        <AlertTriangle
          className="w-16 h-16 text-amber-500 shrink-0"
          aria-hidden
        />
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
          Упс, что-то пошло не так!
        </h1>
        <p className="text-gray-600 max-w-md">
          Попробуйте перезагрузить страницу или вернуться на главную.
        </p>
        <div className="mt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link href={ROUTES.home} onClick={onNavigateHome}>
            <Button color="primary" size="lg">
              На главную
            </Button>
          </Link>
          {onRetry ? (
            <Button size="lg" variant="bordered" onPress={onRetry}>
              Попробовать снова
            </Button>
          ) : null}
          <Button size="lg" variant="flat" onPress={handleReload}>
            Перезагрузить
          </Button>
        </div>
      </div>
    </PageWrapper>
  );
};
